import { RefObject, useEffect, useState } from 'react';

/**
 * True while the video of `ref` does not play (and when there is no video). `key` changes when
 * the viewer shows another file, so the hook reads the new element.
 */
export function useVideoPaused(ref: RefObject<HTMLVideoElement | null>, key: string): boolean {
  const [paused, setPaused] = useState(true);
  useEffect(() => {
    const video = ref.current;
    setPaused(video === null ? true : video.paused);
    if (video === null) {
      return undefined;
    }
    const onPlay = () => setPaused(false);
    const onPause = () => setPaused(true);
    video.addEventListener('play', onPlay);
    video.addEventListener('pause', onPause);
    video.addEventListener('ended', onPause);
    return () => {
      video.removeEventListener('play', onPlay);
      video.removeEventListener('pause', onPause);
      video.removeEventListener('ended', onPause);
    };
  }, [ref, key]);
  return paused;
}
